import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-four-one',
  templateUrl: './c4-four-four-one.component.html',
  styleUrls: ['./c4-four-four-one.component.scss']
})
export class C4FourFourOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
